module.exports = __webpack_public_path__ + "assets/retina_CircleInAngleDetailed.a3fe7072e23a2ddb7a25f0c79162717d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/2x/retina_CircleInAngleDetailed.png
// module id = 639
// module chunks = 0